import React, { createContext, useContext, useMemo, useState } from "react"

interface HeaderMenuContextValue {
  hoveredMenu: string | null
  setHoveredMenu: (key: string | null) => void
  closeMenu: (key: string) => void
  isMenuOpen: boolean
}

const HeaderMenuContext = createContext<HeaderMenuContextValue | undefined>(undefined)

export const HeaderMenuProvider = ({ children }: { children: React.ReactNode }) => {
  const [hoveredMenu, setHoveredMenu] = useState<string | null>(null)

  const value = useMemo<HeaderMenuContextValue>(
    () => ({
      hoveredMenu,
      setHoveredMenu,
      closeMenu: (key: string) => {
        setHoveredMenu((current) => (current === key ? null : current))
      },
      isMenuOpen: hoveredMenu !== null,
    }),
    [hoveredMenu]
  )

  return <HeaderMenuContext.Provider value={value}>{children}</HeaderMenuContext.Provider>
}

export const useHeaderMenu = () => {
  const context = useContext(HeaderMenuContext)

  if (!context) {
    throw new Error("useHeaderMenu must be used within a HeaderMenuProvider")
  }

  return context
}
